<a [routerLink]="">
  {{ text }}
</a>
